<template>
    <div class="warehouse_info">仓库信息</div>
</template>

<script>
export default {
    name: 'warehouse-info',
    components: {}
};
</script>

<style lang="less">
</style>
